export const IOS_DOWNLOAD_LINK =
  'https://itunes.apple.com/us/app/chachastation/id1272481966?mt=8'
export const ANDROID_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=com.chachastation.app'
